import React, { Fragment, useState, useEffect, useRef } from 'react';
import 'moment/locale/es';
import { ToastProvider, useToasts } from 'react-toast-notifications';
import { Container, Row, Col, FormGroup, ButtonGroup } from 'react-bootstrap';
import Datetime from 'react-datetime';
import Card from 'components/Card/Card.jsx';
import Button from '../../components/CustomButton/CustomButton';
import language from '../../config/es';
import AsyncSelect from 'react-select/async';
import Select from 'react-select';
import DataTable from 'react-data-table-component';
import app from '../../config/application';
import LabelChargeData from '../../components/Label/labelChargeData';
import { es_vacio } from '../../config/validate';
import dictionary from '../../config/dictionary';
//redux
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../redux/store/hooks';
import { findSocieties } from '../../redux/society.duck';
import { findByConcept, getValuByConcept } from '../../redux/type.duck';
import { findClientBy } from '../../redux/client.duck';
import {
  getSummaryTotal,
  getRowTotal,
  exportToXls,
  cleanSummary,
} from '../../redux/summary.duck';

//Session user
import SessionConfig from '../../config/session_config';
import { getServerTableProps } from './shared/serverTableProps';

const Summary = () => {
  //#region propiedades
  const ref = useRef();
  const { addToast } = useToasts();
  const dispatch = useAppDispatch();
  let [types, setTypes] = useState([]);
  const [showloadingTypes, setShowloadingTypes] = useState(false);
  const [date, setDate] = useState({
    dateIni: new Date(),
  });
  const [society, setSociety] = useState({ value: 0, label: '', error: '' });
  const [conciliationType, setConciliationType] = useState({
    value: 0,
    label: '',
    error: '',
    code: '',
  });
  const [data, setData] = useState({
    page: 0,
    size: 10,
    enable: true,
    totalRows: 0,
    pendingData: false,
    showloadingSociety: false,
    societies: [],
    exportXls: [],
    columns: [],
    openData: [],
    types: [],
    conciliationTypes: [],
    clients: [],
    type: { value: 0, label: language.messages.monitor.lblAll, error: '' },
    auth: JSON.parse(sessionStorage.getItem('user')),
    client: { value: 0, label: '' },
    options: { year: 'numeric', month: 'numeric', day: 'numeric' },
    error: '',
  });
  data.societies = useSelector((store) => store.societyReducer.societies);
  let lsType = useSelector((store) => store.typeReducer.lsType);
  data.conciliationTypes = useSelector((store) => store.typeReducer.types);
  data.clients = useSelector((store) => store.clientReducer.clients);
  data.openData = useSelector((store) => store.summaryReducer.summaryDocuments);
  data.totalRows = useSelector((store) => store.summaryReducer.summaryRows);
  data.exportXls = useSelector((store) => store.summaryReducer.dataXls);
  data.error = useSelector((store) => store.summaryReducer.summaryError);
  //#endregion
  //#region events
  useEffect(() => {
    messageError();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.error]);
  useEffect(() => {
    exportDataToXls();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.exportXls]);
  useEffect(() => {
    updateState(false, 'pendingData');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.openData]);
  useEffect(() => {
    if (lsType.length > 0) {
      lsType.unshift({ value: 0, label: language.messages.monitor.lblAll });
      let ld= lsType.filter((item) => item.value !== '06' && item.value !== '03' );
      setShowloadingTypes(true);
      setTypes(ld);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lsType]);
  useEffect(() => {
    if (data.societies.length > 0) {
      let societyTemp = {
        value: data.societies[0].value,
        label: data.societies[0].label,
        error: '',
      };
      setSociety(societyTemp);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.societies]);

  useEffect(() => {
    if (data.conciliationTypes.length > 0) {
      let aux = {
        value: data.conciliationTypes[0].value,
        label: data.conciliationTypes[0].label,
        code: data.conciliationTypes[0].code,
      };
      setConciliationType(aux);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.conciliationTypes]);

  useEffect(() => {
    void loadSocieties();
    void loadDataTypes();
    initTable();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    ref.current.onRefreshCurrentSession();
  }, [data]);
  //#endregion
  //#region functions
  const viewNotification = (msm, action) => {
    addToast(msm, {
      appearance: action,
      autoDismiss: true,
    });
  };
  const messageError = () => {
    if (data.error !== '') {
      viewNotification(data.error.error, 'error');
    }
  };
  const exportDataToXls = () => {
    if (data.exportXls.length > 0) {
      //adicionando hoja de excel
      let ls = [];
      data.exportXls.forEach((element) => {
        ls.push(
          conciliationType.code !==
            dictionary.configApp.type.summaryOpenDocumentByClient
            ? {
                FECHA: element.sapDate,
                SOCIEDAD: element.society,
                TIPO_SRE: element.type,
                CLIENTE: element.clientId,
                IMPORTE: element.total.toFixed(2),
                MONEDA: element.coinCode
              }
            : {
                FECHA: element.sapDate,
                SOCIEDAD: element.society,
                EJERCICIO: element.year,
                TIPO_SRE: element.type,
                CLIENTE_COD_SAP: element.clientId,
                DOCUMENTO: element.documentSap,
                IMPORTE: element.total.toFixed(2),
                MONEDA: element.coinCode,
                POSICION:element.position,
                TIPO_SAP:element.sapTypeCode,
                CONTABILIZACION:element.accountDate,
                IMPORTE_SIN_SIGNO: element.totalNoSign.toFixed(2),
              }
        );
      });
      //ls.unshift(language.messages.conciliation.columnExp);
      const XLSX = require('xlsx');
      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.json_to_sheet(ls);
      XLSX.utils.book_append_sheet(wb, ws, 'test');
      XLSX.writeFile(
        wb,
        society.label +
          ' ' +
          language.messages.conciliation.file +
          ' ' +
          conciliationType.label +
          ' ' +
          new Date(date.dateIni).toLocaleDateString('es-ES', data.options) +
          '.c.xlsx'
      );
    } else if (data.pendingData) {
      viewNotification(language.messages.conciliation.empty, 'error');
    }
    updateState(false, 'pendingData');
  };
  const initTable = () => {
    data.columns = [
      {
        name: language.messages.conciliation.lblDateIn,
        sortable: false,
        wrap: true,
        width: '110px',
        cell: (row) => (
          <span>
            <i className="fa fa-calendar"></i>{' '}
            <span className="text-primary text-uppercase small-font">
              {row.date}
            </span>
          </span>
        ),
      },
      {
        name: language.messages.conciliation.society,
        sortable: false,
        wrap: true,
        width: '80px',
        cell: (row) => (
          <span>
            <div className="text-uppercase ">{row.society}</div>
          </span>
        ),
      },
      {
        name: language.messages.conciliation.year,
        sortable: false,
        wrap: true,
        width: '100px',
        omit:
          conciliationType.code !==
          dictionary.configApp.type.summaryOpenDocumentByClient,
        cell: (row) => (
          <span>
            <div className="text-uppercase ">{row.year}</div>
          </span>
        ),
      },
      {
        name: language.messages.conciliation.type,
        sortable: false,
        wrap: true,
        width: '80px',
        cell: (row) => (
          <span>
            <div className="text-uppercase ">{row.type}</div>
          </span>
        ),
      },
      {
        name:
          conciliationType.code === dictionary.configApp.type.summaryDetail
            ? language.messages.conciliation.code
            : language.messages.conciliation.lblClientData,
        sortable: false,
        wrap: true,
        width: '150px',
        omit:
          conciliationType.code !== dictionary.configApp.type.summaryDetail &&
          conciliationType.code !==
            dictionary.configApp.type.summaryOpenDocumentByClient,
        cell: (row) => (
          <span>
            <div className="text-uppercase ">{row.clientId}</div>
          </span>
        ),
      },
      {
        name: language.messages.conciliation.document,
        sortable: false,
        wrap: true,
        width: '200px',
        omit:
          conciliationType.code !==
          dictionary.configApp.type.summaryOpenDocumentByClient,
        cell: (row) => (
          <span>
            <div className="text-uppercase ">{row.documentSap}</div>
          </span>
        ),
      },

      {
        name: language.messages.conciliation.amount,
        sortable: false,
        wrap: true,
        width: '150px',
        right: true,
        cell: (row) => (
          <span>
            <div className="text-primary">{row.total.toLocaleString('en')}</div>
          </span>
        ),
      },
      {
        name: language.messages.conciliation.lblCoin,
        sortable: false,
        wrap: true,
        width: '90px',
        cell: (row) => (
          <span>
            <div className="text-uppercase">{row.coinCode}</div>
          </span>
        ),
      },
      {
        name: language.messages.conciliation.lblClientData,
        sortable: false,
        wrap: true,
        width: '300px',
        omit: conciliationType.code !== dictionary.configApp.type.summaryDetail,
        cell: (row) => (
          <span>
            <div className="text-uppercase small-font">{row.clientName}</div>
          </span>
        ),
      },
    ];
    updateState(data.columns, 'columns');
  };
  const loadDataTypes = async () => {
    await dispatch(getValuByConcept(app.data.types.openDocumentType));
    await dispatch(findByConcept(app.data.types.conciliationOpenDocType));
  };
  const loadSocieties = async () => {
    await dispatch(findSocieties(data.auth.id.user.userId));
    updateState(true, 'showloadingSociety');
  };
  const updateState = (value, id) => {
    setData({
      ...data,
      [id]: value,
    });
  };
  const updateDateState = (value, id) => {
    setDate({
      ...date,
      [id]: value,
    });
  };
  const onChangeDate = (dat) => {
    date.dateIni = dat._d;
    updateDateState(dat._d, 'dateIni');
  };
  const updateSelect = async (value, id) => {
    switch (id) {
      case 'society':
        setSociety(value);
        break;
      case 'type':
        updateState(value, 'type');
        break;
      case 'conciliationType':
        setConciliationType(value);
        await dispatch(cleanSummary());
        break;
      default:
        break;
    }
  };
  const changeClient = (value) => {
    if (value === null) {
      data.client = { value: 0, label: '' };
    } else {
      data.client = value;
    }
    updateState(data.client, 'client');
  };
  const promiseOptions = (inputValue) =>
    Promise.resolve(loadDataClient(inputValue));
  const loadDataClient = async (inputValue) => {
    if (inputValue !== undefined && inputValue.length > 3) {
      let json = {
        filter: inputValue,
        society: society.value,
        length: 20,
        page: 0,
      };

      data.clients = await dispatch(findClientBy(json));
      return data.clients;
    }
  };
  const search = async () => {
    let json = {
      society: society.value,
      page: data.page,
      length: data.size,
      type: data.type.value + '',
      typeSumary: conciliationType.code,
      date: new Date(date.dateIni).toLocaleDateString('es-ES', data.options),
      clientCode: data.client.value + '',
    };
    initTable();

    updateState(true, 'pendingData');
    await dispatch(getRowTotal(json));
    await dispatch(getSummaryTotal(json, data.auth.id.user.username));
  };
  const handlePerRowsChange = async (perPage, page) => {
    data.size = perPage;
    data.page = Number.parseInt(page) - 1;
    if (data.page < 0) {
      data.page = 0;
    }
    updateState(data.size, 'size');
    updateState(data.page, 'page');
    void search();
  };
  const handlePageChange = async (page) => {
    data.page = Number.parseInt(page) - 1;
    if (data.page < 0) {
      data.page = 0;
    }
    updateState(data.page, 'page');
    void search();
  };
  const handleFileUpload = async (e) => {
    let json = {
      society: society.value,
      page: 0,
      length: 1000000,
      type: data.type.value + '',
      typeSumary: conciliationType.code,
      date: new Date(date.dateIni).toLocaleDateString('es-ES', data.options),
      clientCode: data.client.value + '',
    };
    updateState(true, 'pendingData');
    await dispatch(exportToXls(json, data.auth.id.user.username));
  };
  //#endregion
  return (
    <Fragment>
      <SessionConfig ref={ref} />
      <div className="main-content">
        <Container fluid={true}>
          <Row>
            <Col md={12}>
              <Card
                content={
                  <Fragment>
                    <Row>
                      <Col sm={3} lg={3} xl={2}>
                        <h6 className="title">
                          {language.messages.conciliation.lbDate}
                        </h6>
                        <FormGroup>
                          <Datetime
                            className="text-uppercase small"
                            timeFormat={false}
                            initialValue={new Date()}
                            onChange={onChangeDate}
                            inputProps={{
                              readOnly: true,
                              className: 'form-control small',
                            }}
                            dateFormat="DD/MM/YYYY"
                          />
                        </FormGroup>
                      </Col>
                      <Col sm={4} lg={4} xl={2}>
                        <h6 className="title">
                          {language.messages.conciliation.society}
                        </h6>
                        <LabelChargeData
                          showloading={data.showloadingSociety}
                        />
                        <FormGroup>
                          <Select classNamePrefix="ui-select"
                            placeholder={language.messages.lblSingleSelect}
                            name="society"
                            options={data.societies}
                            className="text-uppercase small-font"
                            value={{
                              value: society.value,
                              label: society.label,
                            }}
                            onChange={(value) => {
                              void updateSelect(value, 'society');
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col sm={4} lg={4} xl={2}>
                        <h6 className="title">
                          {language.messages.conciliation.type}
                        </h6>
                        <LabelChargeData showloading={showloadingTypes} />
                        <FormGroup>
                          <Select classNamePrefix="ui-select"
                            placeholder={language.messages.lblSingleSelect}
                            name="type"
                            options={types}
                            className="text-uppercase small-font"
                            value={{
                              value: data.type.value,
                              label: data.type.label,
                            }}
                            onChange={(value) => {
                              void updateSelect(value, 'type');
                            }}
                          />
                        </FormGroup>
                      </Col>

                      <Col sm={6} lg={6} xl={3}>
                        <h6 className="title">
                          {language.messages.monitor.lblClient}
                        </h6>
                        <AsyncSelect classNamePrefix="ui-select"
                          maxMenuHeight={120}
                          cacheOptions
                          className="small-font text-uppercase"
                          placeholder={language.messages.lblSingleSelect}
                          name="client"
                          loadOptions={promiseOptions}
                          isClearable={true}
                          value={{
                            value: data.client.value,
                            label: data.client.label,
                          }}
                          onChange={(value) => {
                            changeClient(value);
                          }}
                        />
                      </Col>
                      <Col sm={3} lg={3} xl={2}>
                        <h6 className="title">
                          {language.messages.conciliation.file}
                        </h6>
                        <LabelChargeData showloading={showloadingTypes} />
                        <FormGroup>
                          <Select classNamePrefix="ui-select"
                            placeholder={language.messages.lblSingleSelect}
                            name="conciliationType"
                            options={data.conciliationTypes}
                            className="text-uppercase small-font"
                            value={{
                              value: conciliationType.value,
                              label: conciliationType.label,
                            }}
                            onChange={(value) => {
                              void updateSelect(value, 'conciliationType');
                            }}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm={5} lg={5} xl={3}>
                        <ButtonGroup>
                          <Button
                            disabled={data.pendingData}
                            primary
                            fill
                            font_small
                            type="button"
                            onClick={search}
                          >
                            <i className="fa fa-search"></i>
                            {language.messages.conciliation.search}
                          </Button>
                          <Button
                            disabled={data.pendingData}
                            success
                            fill
                            font_small
                            type="button"
                            onClick={handleFileUpload}
                          >
                            <i className="fa fa-file-excel-o "></i>
                            {language.messages.conciliation.export}
                          </Button>
                        </ButtonGroup>
                      </Col>
                    </Row>
                    <hr />
                    <div className="fresh-datatables">
                      <DataTable
                        noHeader={es_vacio(conciliationType.label)}
                        title={
                          <span className="text-uppercase text-primary">
                            {language.messages.conciliation.title +
                              ' - ' +
                              conciliationType.label}
                          </span>
                        }
                        data={data.openData}
                        columns={data.columns}
                        {...getServerTableProps({
                          data,
                          scrollHeight: '600px',
                          onChangeRowsPerPage: handlePerRowsChange,
                          onChangePage: handlePageChange,
                        })}
                      />
                    </div>
                  </Fragment>
                }
              />
            </Col>
          </Row>
        </Container>
      </div>
    </Fragment>
  );
};

const App = () => (
  <ToastProvider>
    <Summary />
  </ToastProvider>
);
export default App;
